import { jsxs as _jsxs } from "react/jsx-runtime";
import { Styled } from './character-counter.styles';
export const CharacterCounter = ({ currentCount, maxCount, }) => (_jsxs(Styled.CharacterCounter, { "$maxCountReached": currentCount > maxCount, size: "xsmall", children: [currentCount, "/", maxCount] }));
//# sourceMappingURL=character-counter.js.map